import { Injectable, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class server {

  constructor(public http: HttpClient) { }

  post(endpoint, data, header) {
    const url = endpoint;
    const res = this.http.post(url, data, {headers: header});
    return res;
  }
  
  get(endpoint) {
    const res = this.http.get(endpoint);
    return res;
  }
  
}
